import styled from "styled-components";
import { Link } from 'react-router-dom';
export const ErrBack = styled.section`
    background:#111221;
`;
export const ErrTitle = styled.h1`
    color:#fff;
    text-align:center;
    margin:auto;
    padding:3rem;
    font-weight:inherit;
    font-size:2.7rem;
    text-transform:uppercase;
`;
export const ErrSubTitle = styled.h2`
    color:#fff;
    text-align:center;
    margin:auto;
    padding:1rem;
    font-weight:inherit;
`;
export const ErrCode = styled.code`
    color:#fff;
    text-align:center;
    margin:auto;
    display:block;
    padding:2rem;
    font-size:1.5rem;
`;
export const ErrBtnTitle = styled.span`
    color:#fff;
    text-align:center;
    margin:auto;
    font-size:1.2rem;
`;
export const BtnHome = styled(Link)`
    color:#000;
    cursor:pointer;
    text-decoration:none;
    font-size:0.8rem;
    text-align:center;
    font-weight:inherit;
    background:#e8175d;
    width:10%;
    padding:1rem;
    border-radius:5px;
    display:block;
    margin:auto;
`;
export const ErrEsp = styled.br``;